import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/servicios/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Mensajes } from 'src/app/Class/mensajes';
import { Loading } from 'src/app/Class/Loading';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    constructor(public servi: UserService, private router: Router, public loading: Loading) { }

    public error: string;

    public form = new FormGroup ({
        // email: new FormControl('gestionnormativa@unimagdalena.edu.co', Validators.required),
        // password: new FormControl('admin123', Validators.required)
        email: new FormControl('', Validators.required),
        password: new FormControl('', Validators.required)
    });

    ngOnInit() {}

    iniciar() {

      if ( !this.form.valid ) { return; }

      this.loading.estado = true;
      this.error = null;

      this.servi.userAuthentication( this.form.get('email').value, this.form.get('password').value )
        .subscribe( data => {
          
          if (data['success']) {
            localStorage.setItem('userToken', data['userToken']);
            localStorage.setItem('userName', data['userName']);
            localStorage.setItem('userRoles', JSON.stringify(data['userRoles']) );
            this.router.navigate(['/dashboard']);
          } else {
             this.error = Mensajes.errorLogin;
          }

          this.loading.estado = false;

        }, (err: HttpErrorResponse) => {  this.loading.estado = false; });

    }

}
